// Tipo para productos en el checkout
type TCheckoutProduct = {
  id?: string;
  code?: string;
  productId?: string;
  size?: string;
  prices: {
    current: number;
  };
  camperoneOrderId?: string;
  giftCard?: string | null;
  parentId?: string;
};

// Tipo para el producto formateado para checkout
type TFormattedCheckoutProduct = {
  id: string;
  size?: string;
  price: number;
  camperoneOrderId?: string | null;
  giftCard?: string | null;
  additionalProducts?: string[];
};

/**
 * Formatea productos para el proceso de checkout
 * Agrupa productos padre con sus productos adicionales
 */
export function formatProductsForCheckout(products: TCheckoutProduct[]): TFormattedCheckoutProduct[] {
  const productsCopy = JSON.parse(JSON.stringify(products)) as TCheckoutProduct[];

  // Agrupa productos por parentId
  const productsWithParent = productsCopy.reduce(
    (acc: Record<string, TCheckoutProduct[]>, product: TCheckoutProduct) => {
      if (product.parentId) {
        if (acc[product.parentId]) {
          acc[product.parentId]!.push(product);
        } else {
          acc[product.parentId] = [product];
        }
      }
      return acc;
    },
    {} as Record<string, TCheckoutProduct[]>,
  );

  // Procesa productos principales (sin parentId)
  const newProducts = products.reduce((acc: TFormattedCheckoutProduct[], product: TCheckoutProduct) => {
    const { code, productId, size, prices, camperoneOrderId, giftCard, parentId, id } = product;

    const productToReturn: TFormattedCheckoutProduct = {
      id: productId || code || '',
      size,
      price: prices.current,
      camperoneOrderId: camperoneOrderId || null,
      giftCard: giftCard || null,
    };

    // Si no tiene parent id, es un producto principal
    if (!parentId && id) {
      // Verifica si hay productos adicionales
      const additionalProducts = productsWithParent[id];
      if (additionalProducts) {
        productToReturn.additionalProducts = [];
        additionalProducts.forEach((additionalProduct: TCheckoutProduct) => {
          productToReturn.additionalProducts?.push(additionalProduct.productId || additionalProduct.code || '');
          productToReturn.price += additionalProduct.prices.current;
        });
      }
      acc.push(productToReturn);
    }
    return acc;
  }, []);

  return newProducts;
}
